export class MceSettings {
  public static readonly default: any = {
    plugins: 'link textcolor lists paste',
    menubar: false,
    statusbar: false,
    toolbar: ['bold italic link underline forecolor |' +
              ' alignleft aligncenter alignright |' +
              ' numlist outdent indent |' +
              ' undo redo',
      'formatselect fontselect fontsizeselect'],
    resize: true,
    font_formats: 'Andale Mono=andale mono,times;' + 'Arial=arial,helvetica,sans-serif;' +
                  'Arial Black=arial black,avant garde;' + 'Book Antiqua=book antiqua,palatino;' +
                  'Cambria=cambria;' + 'Georgia=georgia,palatino;' + 'Helvetica=helvetica;' +
                  'Impact=impact,chicago;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' +
                  'Terminal=terminal,monaco;' + 'Times New Roman=times new roman,times;' +
                  'Trebuchet MS=trebuchet ms,geneva;' + 'Verdana=verdana,geneva;' +
                  'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats',
    entity_encoding: 'numeric',
    link_assume_external_targets: true,
    link_context_toolbar: true,
    default_link_target: '_blank',
    link_title:false,
    link_target:false,
    target_list: [{ title: 'New Window', value: '_blank' }],
    extended_valid_elements : 'a[href|target=_blank]',
  };

  public static readonly readonlyDisplay: any = {
    menubar: false,
    statusbar: false,
    toolbar: false,
    resize: false,
    inline: true,
    readonly: 1,
  };

  public static readonly inlineNoControls: any = {
    menubar: false,
    statusbar: false,
    toolbar: false,
    resize: false,
    inline: true,
    entity_encoding: 'numeric',
  };
}
